/* eslint-disable react/no-unused-prop-types */
/* eslint-disable react/prop-types */
/* eslint-disable camelcase */
import React from 'react';
import PropTypes from 'prop-types';

import LoginOptionTab from 'components/LoginOptionTab';

import gubUyLogo from 'assets/logos/gubuy.svg';
import basicoIntermedio from 'assets/icons/basico_intermedio.svg';
import avanzado from 'assets/icons/avanzado.svg';
import { OpenID4Verification } from './OpenID4Verification';

const SECURITY_LEVEL_MAP = {
  avanzado: {
    nombre: 'Avanzado',
    logo: avanzado,
  },
  basico: {
    nombre: 'Básico o intermedio',
    logo: basicoIntermedio,
  },
  intermedio: {
    nombre: 'Básico o intermedio',
    logo: basicoIntermedio,
  },
};

const DEFAULT_SECURITY_LEVEL = {
  nombre: '',
  logo: '',
};

export const obtenerNivelDeSeguridadParaListado = nivel_seguridad =>
  SECURITY_LEVEL_MAP[nivel_seguridad?.toLowerCase()] ?? DEFAULT_SECURITY_LEVEL;

export const LoginOption = ({
  name,
  handleClick,
  className,
  logo,
  description,
  nivel_seguridad,
  nivel_seguridad_logo,
  identifier,
}) => (
  <div className={`login-option ${className}`}>
    <LoginOptionTab
      className="login-option__button"
      handleClick={e => {
        handleClick(e, identifier);
      }}
      text={name}
      logo={logo}
      description={description}
      nivel_seguridad={nivel_seguridad}
      nivel_seguridad_logo={nivel_seguridad_logo}
    />
  </div>
);

LoginOption.propTypes = {
  text: PropTypes.string,
  name: PropTypes.string,
  logo: PropTypes.any,
  handleClick: PropTypes.func,
  className: PropTypes.string,
  loading: PropTypes.bool,
  nivel_seguridad: PropTypes.string,
  description: PropTypes.string,
};

LoginOption.defaultProps = {
  className: '',
  // eslint-disable-next-line react/default-props-match-prop-types
  style: null,
  nivel_seguridad: '',
  description: '',
};

export const LoginSection = ({
  gub_uy_allowed,
  identityProviders,
  handleNext,
}) => {
  const LoginList = identityProviders.map((idp, index) => (
    <LoginOption
      // eslint-disable-next-line react/no-array-index-key
      key={index}
      identifier={idp.identifier}
      name={idp.name}
      ariaLabel={idp.ariaLabel}
      logo={idp.logo}
      description={idp.description}
      nivel_seguridad={
        obtenerNivelDeSeguridadParaListado(idp.nivel_seguridad).nombre
      }
      nivel_seguridad_logo={
        obtenerNivelDeSeguridadParaListado(idp.nivel_seguridad).logo
      }
      handleClick={idp.handleClick}
    />
  ));

  return (
    <div className="login-section">
      {gub_uy_allowed && (
        <LoginOption
          key="gub_uy_option"
          identifier="usuarioGubUy"
          name="Usuario Gub.uy"
          ariaLabel="Accede con Usuario Gub.uy"
          logo={gubUyLogo}
          description="Realiza trámites con tu número de documento y contraseña"
          nivel_seguridad="Básico o intermedio"
          nivel_seguridad_logo={basicoIntermedio}
          handleClick={handleNext}
        />
      )}
      {identityProviders.length > 0 && identityProviders !== null && (
        <div>{LoginList}</div>
      )}
      <OpenID4Verification />
    </div>
  );
};

LoginOption.propTypes = {
  gub_uy_allowed: PropTypes.bool,
  identityProviders: PropTypes.array,
};
